import React from "react";
import PropTypes from "prop-types";
import OneChart from "./OneChart";
import moment from "moment";
import styled from "styled-components";

const ChartsContainer = styled.div`
  overflow: auto;
  height: 100%;
`;
const ChartWrapper = styled.div`
  text-align: end;
  margin-bottom: 2em;
`;

const UNITS = {
  W: "W",
  KW: "kW",
  V: "V",
  KWH: "kWh",
  A: "A",
};

export const normalize = (raw) => {
  if (raw.length === 0) {
    return [];
  }
  const res = [];
  const setNames = raw.map((set, idx) => `set${idx}`);
  const times = Object.keys(raw[0]);
  times.forEach((time) => {
    const hour = moment(time).format("HH:mm");
    const item = { name: hour };
    raw.forEach((set, idx) => {
      const num = parseFloat(set[time], 10);
      item[setNames[idx]] = isNaN(num) ? null : num;
    });
    res.push(item);
  });
  return res;
};

export const normalize2 = (raw, inverters = null) => {
  if (raw.length === 0) {
    return [];
  }
  if (!inverters) {
    inverters = [];
  }
  const res = [];
  const setNames = raw.map((set, idx) => inverters[idx] || `set-${idx}`);

  raw.forEach((set, idx) => {
    const data = Object.keys(set).map((timeStr) => {
      const num = parseFloat(set[timeStr], 10);
      return {
        time: moment(timeStr).valueOf(),
        value: isNaN(num) ? null : num,
      };
    });
    const chartSet = {
      name: setNames[idx],
      data,
    };
    res.push(chartSet);
  });

  return res;
};

const chartsMeta = [
  {
    key: "invPower",
    title: "Inv Power",
    unitsExtractor: ({ inverterPowerFactor: pf }) => {
      return Number.isFinite(pf) && pf < 1 ? UNITS.W : UNITS.KW;
    },
    normalizer: normalize2,
  },
  {
    key: "invDcVoltage",
    title: "Inv DC Voltage",
    unitsExtractor: () => UNITS.V,
    normalizer: normalize2,
  },
  {
    key: "invAcVoltageMin",
    title: "Inv AC Voltage Min",
    unitsExtractor: () => UNITS.V,
    normalizer: normalize2,
  },
  {
    key: "invAcVoltageMax",
    title: "Inv AC Voltage Max",
    unitsExtractor: () => UNITS.V,
    normalizer: normalize2,
  },
  {
    key: "invAcVoltage",
    title: "Inv AC Voltage",
    unitsExtractor: () => UNITS.V,
    normalizer: normalize2,
  },
  {
    key: "invEnergy",
    title: "Inv Energy",
    unitsExtractor: () => UNITS.KWH,
    normalizer: normalize2,
  },
  {
    key: "sysPower",
    title: "Sys Power",
    unitsExtractor: () => UNITS.KW,
    normalizer: normalize2,
  },
  {
    key: "sysEnergy",
    title: "Sys Energy",
    unitsExtractor: () => UNITS.KWH,
    normalizer: normalize2,
  },
  {
    key: "chanDcCurrent",
    title: "Channel DC Current",
    unitsExtractor: () => UNITS.A,
    normalizer: normalize2,
  },
  {
    key: "chanDcPowerInput",
    title: "Channel DC Power Input",
    unitsExtractor: () => UNITS.KW,
    normalizer: normalize2,
  },
];

class DataCharts extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <ChartsContainer>
        <div>
          {chartsMeta.map((chart) => {
            const units = chart.unitsExtractor(this.props.dataSys);
            const label = `${chart.title} (${units})`;
            return (
              chart.key in this.props.data && (
                <ChartWrapper key={chart.key}>
                  {label}
                  <OneChart
                    label={label}
                    units={units}
                    data={chart.normalizer(
                      this.props.data[chart.key],
                      chart.key.startsWith("inv") ||
                        chart.key.startsWith("chan")
                        ? this.props.inverters
                        : null,
                    )}
                    sets={this.props.data[chart.key]}
                  />
                </ChartWrapper>
              )
            );
          })}
        </div>
      </ChartsContainer>
    );
  }
}

export default DataCharts;
